
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-slate-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="text-2xl font-bold mb-4">
              Elbert Alexander
            </div>
            <p className="text-slate-300 mb-4 max-w-md">
              Inspiring dreams, transforming lives, and empowering purpose through faith-based writing, 
              speaking, and transformational workshops.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/profile.php?id=61581833590031&__cft__[0]=AZVDGoDXjPY4EKMa323EdgHjd-rnMMlDg9fiDOy9TH411E-R3xfzqxhTzTV3wp7OImCYevDzHN9LMS7YZMjykd8CQJnYlVwOc4Fl3wovqnKeErceHHXUqwTm4w8Xd37htikZC40ZwZMRbxHpEXSp6KHiA45Tsexeruup4wNkok2Q_D2ekhvBlITJ9wKO-aMtvjedRlfIgEK6JssCW7OCk83w&__tn__=-UC%2CP-R" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-slate-700 rounded-lg hover:bg-slate-600 transition-colors cursor-pointer">
                <i className="ri-facebook-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-slate-700 rounded-lg hover:bg-slate-600 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-slate-700 rounded-lg hover:bg-slate-600 transition-colors cursor-pointer">
                <i className="ri-linkedin-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-slate-700 rounded-lg hover:bg-slate-600 transition-colors cursor-pointer">
                <i className="ri-youtube-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-slate-300 hover:text-white cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-slate-300 hover:text-white cursor-pointer">
                  About
                </Link>
              </li>
              <li>
                <Link to="/shop" className="text-slate-300 hover:text-white cursor-pointer">
                  Books
                </Link>
              </li>
              <li>
                <Link to="/workshops" className="text-slate-300 hover:text-white cursor-pointer">
                  Workshops
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-slate-300 hover:text-white cursor-pointer">
                  Insights
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-300 hover=text-white cursor-pointer">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Services</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/speaking" className="text-slate-300 hover:text-white cursor-pointer">
                  Speaking Engagements
                </Link>
              </li>
              <li>
                <Link to="/workshops" className="text-slate-300 hover:text-white cursor-pointer">
                  Dream Again Workshop
                </Link>
              </li>
              <li>
                <Link to="/workshops" className="text-slate-300 hover:text-white cursor-pointer">
                  Vision Mapping Intensive
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-slate-300 text-sm">
            © 2025 Elbert C. Alexander. All rights reserved. "Inspiring dreams, transforming lives."
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            className="text-slate-400 hover:text-slate-300 text-sm mt-4 md:mt-0 cursor-pointer"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}
